import { defineAsyncComponent } from 'vue'
import axios from 'axios'
export default{
    components:{
        adskeletSliderAndImg: defineAsyncComponent(() =>
            import('@/components/admin/skelet/skeletSliderAndImg.vue')
        ),
        adDoctorAll: defineAsyncComponent(() =>
            import('@/components/admin/skelet/skeletDoctorAll.vue')
        ),
        adskeletInformation: defineAsyncComponent(() =>
            import('@/components/admin/skelet/skeletInformation.vue')
        ),        
        adskeletRecord: defineAsyncComponent(() =>
            import('@/components/admin/skelet/skeletRecord.vue')
        ),        
        adskeletNews: defineAsyncComponent(() =>
                import('@/components/admin/skelet/skeletNewsAll.vue')
        ),
        adskeletLinks: defineAsyncComponent(() =>
                import('@/components/admin/skelet//skeletLinks.vue')
        ),
        skeletMainDostor:defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletMainDostor.vue')
        ),
        adskeletHTML: defineAsyncComponent(() =>
                import('@/components/admin/skelet/skeletHTML.vue')
        ),
        adskeletLinksItem: defineAsyncComponent(() =>
                import('@/components/admin/skelet/skeletLinksItem.vue')
        ),
        adHR:defineAsyncComponent(() =>
                import('@/components/admin/skelet/skeletHR.vue')
        ),
        adskeleVacancies: defineAsyncComponent(() =>
                import('@/components/admin/skelet/skeleVacancies.vue')
        ),
        skeletDeputiesAndManagers: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletDeputiesAndManagers.vue')
        ),
        skeletComments: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletComments.vue')
        ),
        skeletGosService: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletGosService.vue')
        ),
        skeletMinzdrav: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletMinzdrav.vue')
        ),
        skeletOfficesPanels: defineAsyncComponent(() =>
                import('@/components/skeletonComponent/skeletOfficesPanels.vue')
        ),

        
    },
    methods:{
        getSkeleton(path){
            axios
                .get('https://mosp51.ru/api/skeleton?path='+path)
                .then(response=>{
                    this.skeleton = response.data
                })
        }, 
    },
    data(){
        return{
            skeleton:[],
        }
    }

}
